// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"201":"media","594":"about","854":"menu","996":"franchise"}[chunkId] || chunkId) + "." + {"39":"16b79c25","201":"97c8d654","253":"e17f2729","389":"796042c6","466":"0a4e5af6","593":"953480c1","594":"788256d0","838":"bec567ef","854":"1b79428d","996":"8b9bb3fd"}[chunkId] + ".js";
};